import { useState } from "react";
import { GraduationCap, Globe, Car, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { EMPLOYMENT } from "./hrUtils";

const Toggle = ({ icon: Icon, label, desc, value, onChange, testId }) => (
  <button type="button" role="switch" aria-checked={value} onClick={() => onChange(!value)} data-testid={testId}
    className={`flex items-center gap-3 px-3 py-2.5 border text-left transition-colors ${value ? "border-zinc-900 bg-zinc-900 text-white" : "border-zinc-300 bg-white hover:border-zinc-900"}`}>
    <Icon className="w-4 h-4 shrink-0" />
    <div className="min-w-0 flex-1">
      <div className="text-xs font-black uppercase tracking-wider">{label}</div>
      <div className={`text-[10px] ${value ? "text-zinc-300" : "text-zinc-500"}`}>{desc}</div>
    </div>
    <span className={`w-8 h-4 rounded-full relative shrink-0 ${value ? "bg-emerald-400" : "bg-zinc-300"}`}><span className={`absolute top-0.5 w-3 h-3 rounded-full bg-white transition-all ${value ? "left-4.5 translate-x-4" : "left-0.5"}`} /></span>
  </button>
);

export const ProfileToggles = ({ file, onSaved }) => {
  const [p, setP] = useState(file.profile);
  const [busy, setBusy] = useState(false);
  const dirty = JSON.stringify(p) !== JSON.stringify(file.profile);
  const save = async () => {
    setBusy(true);
    try { await api.put(`/hr/employees/${file.employee.id}/profile`, p); toast.success("Profil kadrowy zapisany"); onSaved(); }
    catch { toast.error("Nie udało się zapisać profilu"); }
    finally { setBusy(false); }
  };
  return (
    <section data-testid="hr-profile" className="space-y-3">
      <div className="font-label">// Profil kadrowy — od niego zależy lista wymaganych dokumentów</div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        <Toggle icon={GraduationCap} label="Student" desc="do 26 lat · zaświadczenie z uczelni" value={p.is_student} onChange={(v) => setP({ ...p, is_student: v })} testId="hr-toggle-student" />
        <Toggle icon={Globe} label="Cudzoziemiec" desc="karta pobytu · zezwolenie na pracę" value={p.is_foreigner} onChange={(v) => setP({ ...p, is_foreigner: v })} testId="hr-toggle-foreigner" />
        <Toggle icon={Car} label="Kierowca" desc="prawo jazdy · badania · BHP" value={p.is_driver} onChange={(v) => setP({ ...p, is_driver: v })} testId="hr-toggle-driver" />
      </div>
      <div className="flex flex-wrap items-end gap-2">
        <label className="block"><span className="font-label text-[10px] block mb-1">Forma zatrudnienia</span>
          <select value={p.employment_type} onChange={(e) => setP({ ...p, employment_type: e.target.value })} data-testid="hr-employment-select" className="h-10 px-2 border border-zinc-300 text-sm bg-white outline-none focus:border-zinc-900">
            <option value="auto">Automatycznie z umowy ({EMPLOYMENT[file.employment_type]?.label || "brak"})</option>
            {Object.entries(EMPLOYMENT).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
          </select></label>
        <label className="block"><span className="font-label text-[10px] block mb-1">Rachunki domyślnie</span>
          <select value={p.rachunek_mode} onChange={(e) => setP({ ...p, rachunek_mode: e.target.value })} data-testid="hr-rachunek-mode-select" className="h-10 px-2 border border-zinc-300 text-sm bg-white outline-none focus:border-zinc-900">
            <option value="generate">Generuję w aplikacji</option>
            <option value="manual">Odhaczam ręcznie (skan)</option>
          </select></label>
        <label className="block flex-1 min-w-[200px]"><span className="font-label text-[10px] block mb-1">Notatki kadrowe</span>
          <input type="text" value={p.notes} onChange={(e) => setP({ ...p, notes: e.target.value })} data-testid="hr-profile-notes" className="w-full h-10 px-2 border border-zinc-300 text-sm outline-none focus:border-zinc-900" placeholder="np. zmiana adresu od marca" /></label>
        <button type="button" onClick={save} disabled={!dirty || busy} data-testid="hr-profile-save" className="h-10 px-4 inline-flex items-center gap-1.5 bg-zinc-900 text-white text-xs font-heading font-black uppercase tracking-wider hover:bg-brand disabled:opacity-40 transition-colors"><Save className="w-3.5 h-3.5" />Zapisz profil</button>
      </div>
    </section>
  );
};
